import React, { useState, useEffect } from 'react';
import { noticeAPI } from '../../services/api';
import { useNavigate, useParams } from 'react-router-dom';
import PageTitle from '../shared/PageTitle';

const RuleForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    if (isEdit) {
      const fetchRule = async () => {
        try {
          const response = await noticeAPI.getRule(id);
          setTitle(response.data.title);
          setDescription(response.data.description);
        } catch (err) {
          console.error('Error fetching rule:', err);
          setError('Failed to load rule.');
        }
      };
      fetchRule();
    }
  }, [id, isEdit]);

  const validateForm = () => {
    const errors = {};
    const trimmedTitle = title.trim();
    const trimmedDescription = description.trim();

    if (!trimmedTitle) {
      errors.title = 'Title is required and cannot be empty';
    }
    if (!trimmedDescription) {
      errors.description = 'Description is required and cannot be empty';
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    
    if (!validateForm()) {
      return;
    }

    try {
      const trimmedTitle = title.trim();
      const trimmedDescription = description.trim();
      
      if (isEdit) {
        await noticeAPI.updateRule(id, { 
          title: trimmedTitle, 
          description: trimmedDescription 
        });
      } else {
        await noticeAPI.createRule({ 
          title: trimmedTitle, 
          description: trimmedDescription 
        });
      }
      navigate('/admin/rules');
    } catch (err) {
      console.error('Error saving rule:', err);
      setError('Failed to save rule.');
    }
  };

  const handleDelete = async () => {
    if (isEdit && window.confirm('Are you sure you want to delete this rule?')) {
      try {
        await noticeAPI.deleteRule(id);
        navigate('/admin/rules');
      } catch (err) {
        console.error('Error deleting rule:', err);
        setError('Failed to delete rule.');
      }
    }
  };

  return (
    <div className="container-fluid mt-4 activity-container">
      <PageTitle 
        icon="fa-gavel" 
        title={isEdit ? 'Edit Rule' : 'Create New Rule'} 
        action={
          <button 
            type="button" 
            className="btn btn-outline-secondary" 
            onClick={() => navigate(-1)}
          >
            <i className="fas fa-arrow-left me-2"></i>Back
          </button>
        }
      />
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Title</label>
              <input
                type="text"
                className={`form-control ${validationErrors.title ? 'is-invalid' : ''}`}
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                  if (validationErrors.title) {
                    setValidationErrors(prev => ({ ...prev, title: '' }));
                  }
                }}
                
              />
              {validationErrors.title && (
                <div className="invalid-feedback">{validationErrors.title}</div>
              )}
            </div>
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                className={`form-control ${validationErrors.description ? 'is-invalid' : ''}`}
                rows="4"
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                  if (validationErrors.description) {
                    setValidationErrors(prev => ({ ...prev, description: '' }));
                  }
                }}
                
              />
              {validationErrors.description && (
                <div className="invalid-feedback">{validationErrors.description}</div>
              )}
            </div>
            <div className="d-flex justify-content-between">
              <div>
                <button type="submit" className="btn btn-primary me-2">
                  <i className="fas fa-save me-1"></i>Save
                </button>
                <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>
                  <i className="fas fa-times me-1"></i>Cancel
                </button>
              </div>
              {isEdit && (
                <button type="button" className="btn btn-danger" onClick={handleDelete}>
                  <i className="fas fa-trash me-1"></i>Delete
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RuleForm; 